<template>
  <div>
    <v-btn
      v-if="hideLanguageOption || !splashHeaderAllowLocale || this.$vuetify.breakpoint.mdAndDown"
      rounded
      class="sign-in-button sn-btn"
      height="40"
      :color="translucentButtonColor"
      :elevation="elevation"
      :tabindex="0"
      @click="handleClick"
    >
      <v-icon
        left
      >
        sn-icon-person
      </v-icon>
      {{ signInSignInButton }}
    </v-btn>

    <v-btn
      v-else
      rounded
      class="sign-in-button sn-btn"
      height="40"
      :color="translucentButtonColor"
    >
      <v-btn
        text
        color="white"
        class="inner-button sn-btn"
        :tabindex="0"
        @click="switchLocale()"
      >
        <v-icon
          left
        >
          sn-icon-earth
        </v-icon>
        {{ locale.text }}
      </v-btn>
      <v-spacer> | </v-spacer>
      <v-btn
        text
        color="white"
        class="inner-button sn-btn"
        @click="handleClick"
      >
        <v-icon
          left
        >
          sn-icon-person
        </v-icon>
        {{ signInSignInButton }}
      </v-btn>
    </v-btn>
  </div>
</template>

<script>
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'
import localeMixin from '../../Onboarding/Shared/localeMixin.js'

export default {
  name: 'SignInButton',
  mixins: [localeMixin],
  props: {
    hideLanguageOption: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    elevation: undefined,
    inFocus: false
  }),
  computed: {
    translucentButtonColor () {
      return this.inFocus ? 'rgb(91, 91, 91, 0.7)' : this.rgbaFromHexAndOpacity(this.$vuetify.theme.themes.dark.tertiary, 0.7)
    },
    sac () {
      return this.$route.params.code
    },
    locale () {
      return document.cookie.includes('locale=en') ? { text: 'Español', code: '/es' } : { text: 'English', code: '/en' }
    },
    splashHeaderAllowLocale () {
      return this.$store?.borrowerWebContent?.splashHeaderAllowLocale
    },
    signInSignInButton () {
      return this.$store?.borrowerWebContent?.signInSignInButton ?? 'Sign in'
    }
  },
  methods: {
    handleClick () {
      if (this.$route.path.includes('partner')) {
        window.location.href = '/login'
      } else if (this.sac) {
        window.location.href = `/borrower/login/${this.sac}`
      } else {
        window.location.href = '/borrower/login'
      }
    },
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import '~/assets/css/snui';

  .sign-in-button {
    text-transform: none;
    color: $sn-white !important;
  }

  .sign-in-button:focus {
    outline: #055FCC solid 2px;
  }

  .inner-button {
    text-transform: unset;
  }

  .sign-in-button::before {
    display: none;
  }
</style>
